import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvFeedback, AvForm, AvGroup} from 'availity-reactstrap-validation';
import AvField from '../../../shared/component/form/AvField';
import PropTypes from 'prop-types';
import Translate from "../../../shared/language/Translate";
import {PAGE_MODE, PENDING_STATUS} from "../../../shared/utils/Constants";
import Dialog from "../../../shared/component/dialog/Dialog";
import Toolbar from "../../../shared/component/toolbar/Toolbar";
import {toast} from "react-toastify";
import GeneralUtils from "../../../shared/utils/GeneralUtils";
import DateInput from "../../../shared/component/form/DateInput";

const data = {
    id: '',
    description: '',
    statusReason: 'CUSTOMER_UNREACHABLE',
    pendingEndDate: null
};

export default class PendingDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: data,
            pageMode: null
        }
    }

    render() {
        return (

            <Row className="justify-content-center">
                <Col md="8">
                    <Dialog
                        header={'Askıya Alma Bilgileri'} modal={true} resizable={true}
                        visible={this.state.displayDialog}
                        maximizable={true} responsive={true} onHide={() => {
                        this.setState({displayDialog: false});
                    }}
                        style={{width: '50vw'}}>

                        <AvForm onValidSubmit={this.pending}>
                            <Toolbar display={true}>
                                <div className="p-toolbar-group-right">
                                    <Button color="primary" className="float-right" type="submit">
                                        Kaydet
                                    </Button>
                                    <Button color="primary" className="float-right"
                                            onClick={() => {
                                                this.setState({displayDialog: false});
                                            }}>
                                        Vazgeç
                                    </Button>
                                </div>
                            </Toolbar>


                            <AvGroup>
                                <Label for="statusReason">
                                    Askıya Alma Nedeni
                                </Label>
                                <AvField type="select" className="form-control" name="statusReason"
                                         validate={{
                                             required: {
                                                 value: true,
                                                 errorMessage: 'Bu alanın doldurulması zorunludur.'
                                             }
                                         }}
                                         value={this.state.data.statusReason}
                                         onChange={this.__handleChange}>
                                    {PENDING_STATUS.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>
                            </AvGroup>

                            <div className="position-relative form-group">
                                <Label for="pendingEndDate">
                                    Askı Bitiş Tarihi
                                </Label>

                                <DateInput
                                    name="pendingEndDate"
                                    onChange={this.__handleChange}
                                    value={this.state.data.pendingEndDate}
                                    placeholder="Askı Bitiş Tarihini Giriniz"
                                />
                            </div>

                            <AvGroup>
                                <Label for="description">
                                    <Translate contentKey="description">Açıklama</Translate>
                                    <span style={{color: 'red'}}> (*)</span>
                                </Label>
                                <AvField
                                    type="textarea"
                                    className="form-control textAreaHermes"
                                    name="description"
                                    validate={{
                                        maxLength: {
                                            value: 4000,
                                            errorMessage: "Bu alana en fazla 4000 karakter girebilirsiniz."
                                        },
                                        required: {
                                            value: "true",
                                            errorMessage: "Bu alanın doldurulması zorunludur."
                                        }
                                    }}
                                    value={this.state.data.description}
                                    onChange={this.__handleChange}
                                />
                                <AvFeedback>Bu alana en fazla 4000 karakter girebilirsiniz.</AvFeedback>
                            </AvGroup>

                        </AvForm>
                    </Dialog>
                </Col>
            </Row>

        );
    }

    pending = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.data.description)) {
            return toast.warn("Zorunlu Alan : Açıklama Giriniz!");
        }
        if (GeneralUtils.isNullOrEmpty(this.state.data.pendingEndDate)) {
            return toast.warn("Zorunlu Alan : Askı Bitiş Tarihi Giriniz!");
        }
        this.props.pending();
        this.setState({displayDialog: false});
    }

    setData = (data) => {
        this.setState({data: data});
    }

    clearData = () => {
        this.setState({data: Object.assign({}, data)});
    }

    getData = () => {
        return this.state.data;
    }


    __handleChange = (e) => {
    
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let data = this.state.data;
        data[e.target.name] = value;
        this.setState({data: data});
    }

    setDialog = (value) => {
        this.clearData();
        this.setState({displayDialog: value});
    }

}

PendingDialog.propTypes = {
    data: PropTypes.object
};
